import { useEffect, useState } from 'react'

const detectTouchCapability = () => {
  if (typeof window === 'undefined') return false

  const hasTouchPoints =
    typeof navigator !== 'undefined' &&
    typeof navigator.maxTouchPoints === 'number' &&
    navigator.maxTouchPoints > 0

  const hasTouchEvent = 'ontouchstart' in window
  const hasCoarsePointer = window.matchMedia?.('(any-pointer: coarse)').matches ?? false

  return hasTouchPoints || hasTouchEvent || hasCoarsePointer
}

export function useIsTouchCapable() {
  const [isTouchCapable, setIsTouchCapable] = useState(detectTouchCapability)

  useEffect(() => {
    const updateTouchCapability = () => {
      setIsTouchCapable(detectTouchCapability())
    }

    const coarsePointerMedia = window.matchMedia?.('(any-pointer: coarse)')
    const hoverMedia = window.matchMedia?.('(any-hover: none)')

    updateTouchCapability()

    coarsePointerMedia?.addEventListener('change', updateTouchCapability)
    hoverMedia?.addEventListener('change', updateTouchCapability)
    window.addEventListener('touchstart', updateTouchCapability, { passive: true })

    return () => {
      coarsePointerMedia?.removeEventListener('change', updateTouchCapability)
      hoverMedia?.removeEventListener('change', updateTouchCapability)
      window.removeEventListener('touchstart', updateTouchCapability)
    }
  }, [])

  return isTouchCapable
}
